export default [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/login/register.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/tabbar/home.vue')
    },
    {
        path: '/game',
        name: 'game',
        component: () => import('../views/tabbar/game.vue')
    },
    {
        path: '/video',
        name: 'video',
        component: () => import('../views/tabbar/video.vue')
    },
    {
        path: '/mine',
        name: 'mine',
        component: () => import('../views/tabbar/mine.vue')
    },
    {
        path: '/beautyDetail',
        name: 'beautyDetail',
        component: () => import('../views/other/beautyDetail.vue')
    },
    {
        path: '/personalReport',
        name: 'personalReport',
        component: () => import('../views/other/personalReport.vue')
    },
    {
        path: '/myMsg',
        name: 'myMsg',
        component: () => import('../views/other/myMsg.vue')
    },
    {
        path: '/videoPlayer',
        name: 'videoPlayer',
        component: () => import('../views/other/videoPlayer.vue')
    },
    {
        path: '/lottery',
        name: 'lottery',
        component: () => import('../views/lottery/index.vue')
    },
    {
        path: '/lotteryRecord',
        name: 'lotteryRecord',
        component: () => import('../views/lottery/lotteryRecord.vue')
    },
    {
        path: '/setting',
        name: 'setting',
        component: () => import('../views/setting/index.vue')
    },
    {
        path: '/changePsd',
        name: 'changePsd',
        component: () => import('../views/setting/changePsd.vue')
    },
    {
        path: '/changePayPsd',
        name: 'changePayPsd',
        component: () => import('../views/setting/changePayPsd.vue')
    },
    {
        path: '/language',
        name: 'language',
        component: () => import('../views/setting/language.vue')
    },
    {
        path: '/bindCard',
        name: 'bindCard',
        component: () => import('../views/bankCard/bindCard.vue')
    },
    {
        path: '/myCard',
        name: 'myCard',
        component: () => import('../views/bankCard/myCard.vue')
    },
    {
        path: '/withdrawal',
        name: 'withdrawal',
        component: () => import('../views/wallet/withdrawal.vue')
    },
    {
        path: '/withdrawalRecords',
        name: 'withdrawalRecords',
        component: () => import('../views/wallet/withdrawalRecords.vue')
    },
]